import { render } from "./BindWxUserKey.vue?vue&type=template&id=ed6d8aa6&scoped=true"
import script from "./BindWxUserKey.vue?vue&type=script&lang=js"
export * from "./BindWxUserKey.vue?vue&type=script&lang=js"

import "./BindWxUserKey.vue?vue&type=style&index=0&id=ed6d8aa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed6d8aa6"]])

export default __exports__